export const FETCH_TASK_TYPES = 'FETCH_TASK_TYPES'
export const FETCH_TASK_GROUPS = 'FETCH_TASK_GROUPS'
export const FETCH_TASK_OPERATIONS = 'FETCH_TASK_OPERATIONS'
export const CREATE_TASK_GROUP = 'CREATE_TASK_GROUP'
export const CLEAR = 'CLEAR'

export default {
  FETCH_TASK_TYPES,
  FETCH_TASK_GROUPS,
  FETCH_TASK_OPERATIONS,
  CREATE_TASK_GROUP,
  CLEAR
}
